import type { Response } from 'types/api';
import type {
  PendingPolicyNotice,
  PolicyNoticeEventResult,
  PolicyNoticeEventType,
} from 'types/models/policy';
import { getRequest, postRequest } from 'utils/request';

type GetPendingPolicyNoticesResponse = Response<PendingPolicyNotice[]>;
export const getPendingPolicyNotices = (): Promise<GetPendingPolicyNoticesResponse> =>
  getRequest('/policies/pending');

type PostPolicyNoticeEventResponse = Response<PolicyNoticeEventResult>;
export const postPolicyNoticeEvent = (
  versionId: string,
  type: PolicyNoticeEventType
): Promise<PostPolicyNoticeEventResponse> =>
  postRequest(`/policies/versions/${versionId}/events`, { type });
